var map = {
	"./en/advancedaudit.json": "f5e2",
	"./en/audit.json": "7ff9",
	"./en/boxinspection.json": "de5b",
	"./en/calibration 2.json": "0cb7",
	"./en/calibration.json": "e801",
	"./en/climate.json": "7ce4",
	"./en/common.json": "1e1c",
	"./en/cuttingorder.json": "3572",
	"./en/devices.json": "2485",
	"./en/diseases.json": "1616",
	"./en/fertilization.json": "36d7",
	"./en/grow.json": "1173",
	"./en/inventory.json": "4ed4",
	"./en/irrigation.json": "2435",
	"./en/labor.json": "e359",
	"./en/pqr.json": "4949",
	"./en/production.json": "80b9",
	"./en/pruning.json": "ed5e",
	"./en/quality.json": "e3df",
	"./en/samples.json": "e603",
	"./en/shopping.json": "0b17",
	"./en/sigatoka.json": "b2a0",
	"./en/sowing.json": "b3ab",
	"./en/status.json": "3f1f",
	"./en/tools.json": "b5ce",
	"./en/type.json": "c983",
	"./en/widgets.json": "e6c7",
	"./es/advancedaudit.json": "4a37",
	"./es/audit.json": "16b8",
	"./es/boxinspection.json": "6512",
	"./es/calibration 2.json": "3515",
	"./es/calibration.json": "0e62",
	"./es/climate.json": "d42a",
	"./es/common.json": "6892",
	"./es/cuttingorder.json": "e751",
	"./es/devices.json": "d2ec",
	"./es/diseases.json": "79e2",
	"./es/fertilization.json": "4549",
	"./es/grow.json": "e70b",
	"./es/inventory.json": "dfc8",
	"./es/irrigation.json": "59c8",
	"./es/labor.json": "771d",
	"./es/pqr.json": "3da5",
	"./es/production.json": "0b59",
	"./es/pruning.json": "8af2",
	"./es/quality.json": "ac91",
	"./es/samples.json": "e0c3",
	"./es/shopping.json": "d417",
	"./es/sigatoka.json": "b9f5",
	"./es/sowing.json": "44ba",
	"./es/status.json": "c6fc",
	"./es/tools.json": "13b2e",
	"./es/type.json": "c8cb",
	"./es/widgets.json": "4a95",
	"./pt_BR/advancedaudit.json": "638e",
	"./pt_BR/audit.json": "fd9b",
	"./pt_BR/boxinspection.json": "d383",
	"./pt_BR/calibration 2.json": "e0fe",
	"./pt_BR/calibration.json": "4372",
	"./pt_BR/climate.json": "f6e7",
	"./pt_BR/common.json": "8b0f",
	"./pt_BR/cuttingorder.json": "8da2",
	"./pt_BR/devices.json": "9e69f",
	"./pt_BR/diseases.json": "2f3e",
	"./pt_BR/fertilization.json": "0e78",
	"./pt_BR/grow.json": "355c",
	"./pt_BR/inventory.json": "42ee",
	"./pt_BR/irrigation.json": "2ee8",
	"./pt_BR/labor.json": "a000",
	"./pt_BR/pqr.json": "3823",
	"./pt_BR/production.json": "ca21",
	"./pt_BR/pruning.json": "9622",
	"./pt_BR/quality.json": "cc16",
	"./pt_BR/samples.json": "698b",
	"./pt_BR/shopping.json": "4102",
	"./pt_BR/sigatoka.json": "5ca0",
	"./pt_BR/sowing.json": "a0b1",
	"./pt_BR/status.json": "86a2",
	"./pt_BR/tools.json": "8309",
	"./pt_BR/type.json": "67ef",
	"./pt_BR/widgets.json": "3401"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "49f8";